const cacheObject = {};

import pinyin from "pinyin";

export function getPinyin(name) {
  if (cacheObject[name]) {
    return cacheObject[name];
  } else {
    const py = pinyin(name, {
      style: pinyin.STYLE_NORMAL, // 设置拼音风格
      heteronym: true
    });
    if (py.length > 0) {
      let letters = "";
      py.forEach(node => {
        if (typeof node[0] === "number") {
          node[0] = node[0].toString();
        }
        letters += node[0];
        // if (node.length > 0 && node[0].length > 0) {
        //   firstLetters.push(node[0].charCodeAt(0));
        // }
      });
      cacheObject[name] = letters;
      return letters;
    }
  }
}
